import * as R from 'ramda'
import React, { useState, Fragment, useMemo } from 'react'
import G from '../util/globalFunction'
import { IconButton } from './button'
import { SimpleSelect } from './inputCtrl'
import {
    faAngleDown,
    faAngleUp,
    faPlus,
    faAngleDoubleLeft,
    faAngleLeft,
    faEllipsisH,
    faAngleRight,
    faAngleDoubleRight,
    faCaretUp,
    faCaretDown,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Tooltip from 'react-tooltip-lite'
import { isEmptyObject } from 'jquery'

const getDefaultRenderValue = (type, value) =>
    type === 'commaNumber'
        ? G.numberComma(value)
        : type === 'date'
        ? G.dateFormat(value)
        : type === 'time'
        ? G.dateFormat(value, 'hh:mm:ss')
        : type === 'datetime'
        ? G.dateFormat(value, 'YYYY-MM-DD hh:mm:ss')
        : value

const SortButton = props => {
    const { field, sort, sortField, sortType } = props

    return (
        <span className="text-primary">
            {!sort ? null : field === sortField && ['asc', 'dsc'].includes(sortType) ? (
                <FontAwesomeIcon icon={sortType === 'asc' ? faCaretUp : faCaretDown} />
            ) : (
                <div className="bg-primary" style={{ width: 6, height: 6 }} />
            )}
        </span>
    )
}

const DefaultDataGridHeader = props => {
    const {
        mode,
        columnDefs,
        gridTemplateColumns,
        headerClassName,
        handleAdd,
        sort,
        sortField,
        sortType,
        handleChangeSort,
    } = props

    return (
        <div
            className={
                headerClassName ||
                'py-2 px-2 text-xs md:text-sm text-gray-700 font-semibold text-center grid gap-1 border-t border-gray-500'
            }
            style={{ gridTemplateColumns, background:'#e8ebf0' }}
        >
            {columnDefs.map(({ field, title, sort }, index) => (
                <div
                    key={index}
                    className="flex flex-row gap-1 items-center justify-center"
                    onClick={e => {
                        e.preventDefault()
                        handleChangeSort(field)
                    }}
                >
                    <div>{title}</div>
                    <SortButton
                        field={field}
                        sort={sort}
                        sortField={sortField}
                        sortType={sortType}
                    />
                </div>
            ))}
            {mode === 'L' && handleAdd && (
                <div
                    className="w-8 h-4 bg-primary focus:outline-none rounded-sm text-white cursor-pointer flex items-center justify-center"
                    onClick={() => handleAdd()}
                >
                    <FontAwesomeIcon icon={faPlus} size="sm" />
                </div>
            )}
        </div>
    )
}

/*
type : string(default), number, commaNumber, date, time, datetime
*/

const DetailWrapDiv = props => {
    const { element } = props
    return <div className="w-full p-4 bg-bgColor">{element(props)}</div>
}

export default props => {
    const [state, setState] = useState({
        type: 'L',
        key: 0,
        sortField: null,
        sortType: null,
        filterData: {},
    })
    const { children, data, className, headerClassName, header, rowClassName, detail, style } =
        props

    const { element, handleAdd } = detail || {}

    const defs = React.Children.map(children, ({ type: elementType, props }) => ({
        elementType,
        ...props,
    }))
    let gridTemplateColumns = defs.map(({ width }) => width || '1fr').join(' ')
    gridTemplateColumns += detail ? ' 34px' : ''
    const rowClassNameL =
        (rowClassName ||
            'py-2 border-t bg-white border-gray-200 px-2 text-xs md:text-sm text-gray-500 flex items-center') +
        ' grid gap-1'

    const handleEditMode = (data, dataIndex) => setState({ type: 'E', data, dataIndex })
    const handleClose = data => setState({ type: 'L', key: 0 })
    const handleAddWrap = () => {
        handleAdd ? handleAdd() : setState({ type: 'A' })
    }
    const { sortField, sortType, filterData } = state
    const handleChangeSort = field => {
        setState({
            ...state,
            sortField: field,
            sortType: sortField === field && sortType === 'asc' ? 'dsc' : 'asc',
        })
    }

    const allValue = '(' + G.t('trem.lang.home.0029') + ')' /* const allValue = '(전체)' */

    const filterDispData = defs
        .filter(def => def.filter)
        .map(({ field, type }) => ({
            field,
            values: data.reduce(
                (acc, curr) => {
                    const disp = getDefaultRenderValue(type, curr[field])
                    if (!acc.includes(disp)) {
                        acc.push(disp)
                    }
                    return acc
                },
                [allValue]
            ),
        }))

    const handleFilter = (name, value) => {
        debugger
        if (value === allValue) {
            delete filterData[name]
        } else {
            filterData[name] = value
        }
        setState({ ...state, filterData })
    }

    //필터 먼저
    let dataWrap =
        Object.keys(filterData || {}).length > 0
            ? data.filter(obj => {
                  for (const key of Object.keys(filterData)) {
                      if (!defs.find(def => def.field === key)) {
                          debugger
                      }
                      const { type } = defs.find(def => def.field === key)
                      if (getDefaultRenderValue(type, obj[key]) !== filterData[key]) {
                          return false
                      }
                  }
                  return true
              })
            : [...data]

    //정렬 나중
    if (sortField) {
        dataWrap.sort((a, b) => {
            const ret =
                sortType === 'asc' ? a[sortField] > b[sortField] : a[sortField] < b[sortField]
            return ret ? 1 : -1
        })
    }

    return (
        <div className={className} style={style || null}>
            {header ? (
                header({
                    mode: state.type,
                    columnDefs: defs,
                    handleAdd: detail && handleAddWrap,
                    gridTemplateColumns: gridTemplateColumns,
                })
            ) : (
                <DefaultDataGridHeader
                    mode={state.type}
                    columnDefs={defs}
                    headerClassName={headerClassName}
                    handleAdd={detail && handleAddWrap}
                    sortField={sortField}
                    sortType={sortType}
                    handleChangeSort={handleChangeSort}
                    gridTemplateColumns={gridTemplateColumns}
                />
            )}

            {state.type === 'A' && (
                <div className="w-full border-t-2 border-white">
                    <div>
                        <DetailWrapDiv handleClose={handleClose} {...detail} />
                    </div>
                </div>
            )}
            {


            filterData && filterData?.length > 0 && (
    // filterData?.length === 0 || isEmptyObject(filterData) === true? null : (
                <div className={rowClassNameL} style={{ gridTemplateColumns, minHeight: '2rem' }}>
                    {defs.map((def, index) => {
                        const finded =
                            def.filter && filterDispData.find(obj => obj.field === def.field)
                        return finded ? (
                            <SimpleSelect
                                key={index}
                                name={def.field}
                                def={{
                                    options: finded.values.sort().map(v => ({ key: v, title: v })),
                                }}
                                value={filterData[def.field]}
                                handleChange={handleFilter}
                            />
                        ) : (
                            <div key={index}></div>
                        )
                    })}
                </div>
            )}
            {dataWrap?.length > 0 ? (
                dataWrap.map((row, rowIndex) => (
                    <Fragment key={rowIndex}>
                        <div
                            className={rowClassNameL}
                            style={{ gridTemplateColumns, minHeight: '2rem' }}
                        >
                            {defs.map(
                                (
                                    { elementType, field, type, align, className, render, tooltip },
                                    columnIndex
                                ) => {
                                    const classArray = [className]
                                    align =
                                        align ||
                                        (['number', 'commaNumber'].includes(type) && 'right')
                                    align &&
                                        classArray.push(
                                            align === 'center'
                                                ? 'text-center'
                                                : align === 'right'
                                                ? 'text-right'
                                                : 'text-left'
                                        )

                                    return React.createElement(
                                        elementType,
                                        { key: columnIndex, className: classArray.join(' ') },
                                        <Fragment>
                                            {render ? (
                                                <Fragment>
                                                    {render(row, rowIndex, columnIndex, field)}
                                                </Fragment>
                                            ) : tooltip ? (
                                                <Tooltip content={row[field]}>
                                                    {getDefaultRenderValue(type, row[field])}
                                                </Tooltip>
                                            ) : (
                                                getDefaultRenderValue(type, row[field])
                                            )}
                                        </Fragment>
                                    )
                                }
                            )}
                            {element && (state.type === 'L' || rowIndex === state.dataIndex) && (
                                <div className="flex items-center justify-center">
                                    <IconButton
                                        icon={state.type === 'L' ? faAngleDown : faAngleUp}
                                        handleClick={() =>
                                            state.type === 'L'
                                                ? handleEditMode(row, rowIndex)
                                                : handleClose(row)
                                        }
                                    />
                                </div>
                            )}
                        </div>
                        {state.type === 'E' && rowIndex === state.dataIndex && (
                            <DetailWrapDiv data={row} handleClose={handleClose} {...detail} />
                        )}
                    </Fragment>
                ))
            ) : (
                <div>출력할 자료가 없습니다.</div>
            )}
        </div>
    )
}

export const Pagenation = props => {
    const { totalCount, pageCount, page: initPage, hangleChangePage } = props
    const [page, setPage] = useState(initPage)

    useMemo(() => {
        setPage(0)
    }, [totalCount])

    const maxPage =
        parseInt(totalCount % pageCount) === 0
            ? parseInt(totalCount / pageCount)
            : parseInt(totalCount / pageCount) + 1

    const noramlClass =
        'w-8 h-8 border rounded m-1 text-center p-1 text-gray-600 hover:border-gray-500'
    const currentClass = noramlClass + ' bg-blue-200'

    let startPos = page > 2 ? page - 2 : 0
    const leftEmp = maxPage > 7 && startPos > 0

    let endPos = maxPage <= 6 ? maxPage : startPos + 6 > maxPage ? maxPage : startPos + 6
    const rightEmp = maxPage > endPos
    if (rightEmp) {
        endPos--
    }
    if (maxPage > 7 && maxPage - startPos < 6) startPos = maxPage - 6

    const btnCount = endPos - startPos
    const handleClickPage = page => {
        setPage(page)
        hangleChangePage && hangleChangePage(page)
    }

    return (
        <div className="mx-auto flex flex-row justify-center" style={{ minWidth: 300 }}>
            <a href="javascript:void(0);" className={noramlClass} onClick={() => page && handleClickPage(0)}>
                <FontAwesomeIcon icon={faAngleDoubleLeft} />
            </a>
            <a href="javascript:void(0);" className={noramlClass} onClick={() => page && handleClickPage(page - 1)}>
                <FontAwesomeIcon icon={faAngleLeft} />
            </a>
            {leftEmp && (
                <a href="javascript:void(0);" className="w-8 h-8 my-1 text-center p-1 text-gray-800">
                    <FontAwesomeIcon icon={faEllipsisH} />
                </a>
            )}
            {[...Array(btnCount).keys()].map(value => (
                <a  
                    href="javascript:void(0);"
                    key={value}
                    className={value + startPos === page ? currentClass : noramlClass}
                    onClick={() => handleClickPage(value + startPos)}
                >
                    {value + startPos + 1}
                </a>
            ))}
            {rightEmp && (
                <a href="javascript:void(0);"  className="w-8 h-8 my-1 text-center p-1 text-gray-800">
                    <FontAwesomeIcon icon={faEllipsisH} />
                </a>
            )}
            <a
                href="javascript:void(0);"
                className={noramlClass}
                onClick={() => page < maxPage - 1 && handleClickPage(page + 1)}
            >
                <FontAwesomeIcon icon={faAngleRight} />
            </a>
            <a
                href="javascript:void(0);"
                className={noramlClass}
                onClick={() => page < maxPage && handleClickPage(maxPage - 1)}
            >
                <FontAwesomeIcon icon={faAngleDoubleRight} />
            </a>
        </div>
    )
}
